export default {
    ToggleDisplayLayer: 'toggle-display-layout',
    SelectDisplayBasemap: 'select-base-map',
    RemoveDisplayLayer: 'remove-display-layer',
}